import TableWrap from "../Common/Table/Table";
import { message, Button } from 'antd';
import { useDispatch, useSelector } from "react-redux";
import { userAdvances } from "../../actions/advances/advances";
import { userReportLinkAdv } from "../../actions/reports/reports";
import { objectToFormData } from "../../utils";
import React from "react";
// import moment from "moment";


import "./report.css";
import BaseCurrency from "../Common/BaseCurrency";

message.config({
  maxCount: 3,
});

const LinkAdvances = (props) => {
  const dispatch = useDispatch();
  const [selectedData, setSelectedData] = React.useState([]);
  const advancesResponse = useSelector(state => state.advances.userAdvances || {});
  const userReportLinkAdvResponse = useSelector(
    (state) => state.reports.userReportLinkAdv || {}
  );
  React.useEffect(() => {
    dispatch(userAdvances({ added_to_report: false }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  React.useEffect(() => {
    const { data: { status = false } = {} } =
      userReportLinkAdvResponse;
    if (status) {
      dispatch(userAdvances({ added_to_report: false }));
      handleClearList();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userReportLinkAdvResponse]);

  const { data: { response: { advances = [] } = {}, total_records = 0 } = {} } = advancesResponse;


  const columns = [
    {
      title: "Advance ID",
      dataIndex: "advance_number",
      key: "advance_number",
    },
    {
      title: "Title",
      dataIndex: "title",
      key: "title",
    },
    {
      title: "Date",
      dataIndex: "date",
      key: "date",
    },
    {
      title: "Amount",
      dataIndex: "amount",
      key: "amount",
      render: (text) => <div><BaseCurrency /> {text}</div>,
    }
  ];

  const rowSelection = {
    selectedRowKeys: selectedData,
    onChange: (selectedRowKeys, selectedRows) => {
      console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
      setSelectedData(selectedRowKeys);
    }
  };

  const handleClearList = () => {
    setSelectedData([]);
  }

  const handleAddExp = () => {
    const payload = {};
    payload.advances = selectedData;
    payload.report_id = props.report_id;
    dispatch(userReportLinkAdv(objectToFormData({ ...payload })));
    setSelectedData([]);
  }

  return (
    <div className="advances-table">
      {selectedData.length ?
        <>
          <Button type="default" ghost className="approve-add-btn mb1" onClick={() => handleClearList()}>
            Clear Selection
          </Button>
          <Button
            onClick={() => handleAddExp()}
            className="floatRight ml1 primaryButton"
          >
            Add {selectedData.length > 1 ?selectedData.length : ""} Advances
          </Button></> : null}
      <TableWrap
        rowKey="id"
        columns={columns}
        data={advances}
        className="tableStyled"
        pagination={{
          total: total_records,
          onChange: (pagee) => {
            dispatch(userAdvances(({ added_to_report: false, page: pagee })));
          },
        }}
        rowSelection={{
          type: 'checkbox',
          ...rowSelection,
        }}
      />
    </div>
  );
};

export default LinkAdvances;
